import BaseResource from './index'

export default class RuleCollectionResource extends BaseResource {
    static endpoint = '/oasis/restv3/admin/rulecollections'
}
